"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Functions_exports = {};
__export(Functions_exports, {
  default: () => Functions_default
});
module.exports = __toCommonJS(Functions_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.4141 5.62109V4.41016C11.4115 4.41016 10.526 4.68359 9.75781 5.23047C8.98958 5.76432 8.51432 6.44792 8.33203 7.28125L7.53125 10.0742H5.61719V11.2656H7.25781L6.49609 13.8438C6.37891 14.3906 6.06641 14.8398 5.55859 15.1914C5.0638 15.543 4.49089 15.7188 3.83984 15.7188V16.9102C4.84245 16.9102 5.72135 16.6432 6.47656 16.1094C7.24479 15.5755 7.72005 14.8919 7.90234 14.0586L8.72266 11.2656H10.2656V10.0742H8.97656L9.73828 7.49609C9.85547 6.94922 10.1615 6.5 10.6562 6.14844C11.1641 5.79688 11.75 5.62109 12.4141 5.62109ZM16.1836 8.25781L14.3086 10.2695L12.4336 8.25781L11.457 8.86328L13.5469 11.1484L11.457 13.4141L12.4336 14.0391L14.3086 12.0273L16.1836 14.0391L17.1602 13.4141L15.0703 11.1484L17.1602 8.86328L16.1836 8.25781Z",
      fill: "currentColor"
    }
  )
);
const SvgFunctions = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Functions_default = SvgFunctions;
